<template>
  <div class="content">
    <div class="settings">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12"></div>
            <Card >
            <div class="tab-container" >
              <div v-if="activeTab !== 'general' && activeTab !== 'performance'" class="empoyee-dropdown-container">
                <EmployeeDropdown
                  :employees="$store.state.auth.allUsers"
                  :company="$store.state.auth.company"
                  defaultFilter="active"
                  @update="filteredUsers = $event"
                />
              </div>
              <div class="left-section" style="width: 200px"></div>
              <div class="tabs">
                <button :class="{ active: activeTab === 'general' }" @click="activeTab = 'general'">
                  General Settings
                </button>
                <button v-if="isAdmin" :class="{ active: activeTab === 'employee' }" @click="activeTab = 'employee'">
                  Employee Specific Settings
                </button>
                <button :class="{ active: activeTab === 'performance' }" @click="activeTab = 'performance'">
                  Performance Criteria
                </button>
              </div>
            </div>
 
              <div v-if="activeTab === 'general'" class="settings-content general-settings">
                <div class="settings-grid">
                  <div class="left-section">
                    <div class="form-group">
                      <h5 class="title">Working Days</h5>
                      <div class="checkbox-group">
                        <div class="checkbox-item" v-for="day in weekDays" :key="day">
                          <input type="checkbox" class="" :id="day" v-model="selectedDays" :value="day"
                            :disabled="!isAdmin" />
                          <label :for="day">{{ day }}</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="right-section">
                    <div class="right-section-content">
                      <div class="form-group">
                        <h5 class="title">Total Hours</h5>
                        <input type="number" class="genral-setting-input" v-model="productiveHours" :disabled="!isAdmin"
                          min="0" max="24" />
                      </div>

                      <div class="form-group time-dropdown-container" >
                        <h5 class="title" for="lateTime">Late Time</h5>
                        <div class="time-dropdown" ref="dropdown" style="width: 100%; padding: 3px ;">
                        <div class="selected-time" @click="toggleLateTime('currentUser')">
                          {{ selectedHour }} : {{ selectedMinute }} {{ selectedMeridian }}
                        </div>
                        <div v-if="activeLateDropdown === 'currentUser'" class="time-selector time-selector-genral">
                          <div class="time-columns">
                          <!-- Hours Dropdown -->
                          <LateTimeDropdown :data="hours" :selected="selectedHour"
                            @change="(value) => onHourChange(value)" />

                          <!-- Minutes Dropdown -->
                          <LateTimeDropdown :data="minutes" :selected="selectedMinute"
                            @change="(value) => setMinute(value)" />

                          <!-- Meridians Dropdown -->
                          <LateTimeDropdown :data="meridians" :selected="selectedMeridian"
                            @change="(value) => setMeridian(value)" />
                          </div>

                          <!-- <button class="save-btn-employee" @click="saveLateTime('currentUser')">Save</button> -->
                        </div>
                        </div>
                      </div>
                    </div>
                    <button v-if="isAdmin" class="save-btn" @click="saveGeneralSettings" :disabled="!isAdmin">
                      Save Changes
                    </button>
                  </div>
                </div>

                <div v-if="isSuperAdmin">
                  <hr>
                  <SlackIntegration />
                </div>

                <div v-if="isAdmin">
                <hr>
                <GoogleCalendarIntegration @connected="onCalendarConnected" @disconnected="onCalendarDisconnected" />
              </div>

                
                <div v-if="isAdmin">
                  <hr>
                  <CompanyDetails />
                </div>

                <div v-if="isAdmin">
                  <hr>
                  <EmailTemplateManager />
                </div>
                
                <div>
                  <hr>
                  <PublicHoliday />
                </div>
              </div>

              <!-- Employee Specific Settings -->
              <div v-if="activeTab === 'employee' && isAdmin" class="settings-content">
                <CustomTable :columns="tableColumns" :data="filteredEmployeeList">
                  <template #username="{ item }">
                    <span class="employee-name">{{ item.username }}</span>
                  </template>
                  <template #lateTime="{ item }">
                    <div class="time-dropdown" :ref="'dropdown_employee_' + item.id" refInFor>
                      <div class="selected-time" @click="toggleLateTime(item.id)">
                        {{ item.lateTime }}
                      </div>
                      <div v-if="activeLateDropdown === item.id" class="time-selector">
                        <div class="time-columns">
                          <!-- Hours Dropdown -->
                          <LateTimeDropdown :data="hours" :selected="activeLateDropdown === item.id ? tempLateTime.hour : item.lateTime.split(':')[0]"
                            @change="(value) => onLateTimeChange(value, item.id, 'hour')" />

                          <!-- Minutes Dropdown -->
                          <LateTimeDropdown :data="minutes" :selected="activeLateDropdown === item.id ? tempLateTime.minute : item.lateTime.split(':')[1].split(' ')[0]"
                            @change="(value) => onLateTimeChange(value, item.id, 'minute')" />

                          <!-- Meridians Dropdown -->
                          <LateTimeDropdown :data="meridians" :selected="activeLateDropdown === item.id ? tempLateTime.meridian : item.lateTime.split(' ')[1]"
                            @change="(value) => onLateTimeChange(value, item.id, 'meridian')" />
                        </div>

                        <button class="save-btn-employee" @click="saveLateTime(item.id, $event)">Save</button>
                      </div>
                    </div>
                  </template>

                  <template #productiveHours="{ item }">
                    <input type="number" :value="item.productiveHours"
                      @input="handleInput($event, item.id, 'productiveHours')"
                      @blur="commitInput(item.id, 'productiveHours')"
                      @keydown.enter="commitInput(item.id, 'productiveHours')" min="0" max="24"
                      class="productive-input" />
                  </template>
                  <template #workingDays="{ item }">
                    <div class="workigndayes">
                      <WorkingDays v-model="item.workingDaysObject" @input="updateWorkingDays(item, $event)" />
                    </div>
                  </template>

                  <template #leavesAllowed="{ item }">
                    <input type="number" :value="item.leavesAllowed"
                      @input="handleInput($event, item.id, 'leavesAllowed')"
                      @blur="commitInput(item.id, 'leavesAllowed')"
                      @keydown.enter="commitInput(item.id, 'leavesAllowed')" min="0" max="24"
                      class="productive-input" />
                  </template>
                  <template #leavesAvailable="{ item }">
                    <input type="number" :value="item.leavesAvailable"
                      @input="handleInput($event, item.id, 'leavesAvailable')"
                      @blur="commitInput(item.id, 'leavesAvailable')"
                      @keydown.enter="commitInput(item.id, 'leavesAvailable')" min="0" max="24"
                      class="productive-input" />
                  </template>
                  <template #screenshot="{ item }">
                    <div class="switch-container">
                      <div class="screenshot-label">{{ item.screenshotEnabled ? 'Enabled' : 'Disabled' }}</div>
                      <label class="switch">
                        <input type="checkbox" v-model="item.screenshotEnabled">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </template>
                  <template #specific="{ item }">
                    <div class="switch-container">
                      <div class="spacific-label" data-tooltip="Modifying Late Time, Productive Hours or Working Days only will change it to Specific">
                        {{ item.specificSetting ? 'Specific' : 'General' }}
                      <i class="fas fa-info-circle" style="color: yellowgreen; margin-left:7px" ></i>
                        </div>
                    </div>
                  </template>
                  <template #action="{ item }">
      
                    <div class="action-buttons">
                      <div @click="showUpdateConfirmModal(item)" class="edit-btn btn-status" title="Update" >
                        <i class="fas fa-check" style="color: gray;"></i>
                      </div>
                      <div @click="showResetConfirmModal(item)" class="resets-btn btn-status" title="Reset">
                        <i class="fa fa-undo" style="color: gray;"></i>
                      </div>
                    </div>
                  </template>
                </CustomTable>
              </div>

              <!-- Performance Tab -->
              <div v-if="activeTab === 'performance'" class="settings-content">
                <PerformanceCriteria />
              </div>
            </Card>
          </div>
        </div>
      <!-- </div> -->

      <ReuseableModal :modelValue="showUpdateModal" @update:modelValue="showUpdateModal = $event" title="Confirm Update"
        submitButtonText="Update" @submit="confirmUpdateEmployee">
        <div>Are you sure you want to update settings for {{ selectedEmployee && selectedEmployee.username ?
          selectedEmployee.username : '' }}?</div>
      </ReuseableModal>
      <ReuseableModal :modelValue="showResetModal" @update:modelValue="showResetModal = $event" title="Confirm Reset"
        submitButtonText="Reset" @submit="confirmResetEmployee">
        <div>Are you sure you want to reset settings for {{ selectedEmployee && selectedEmployee.username ?
          selectedEmployee.username : '' }} to default?</div>
      </ReuseableModal>
    </div>
  </div>
</template>

<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import WorkingDays from "src/components/UIComponents/WorkingDays.vue";
import CustomTable from "../../UIComponents/CustomTable.vue";
import ReuseableModal from "../../UIComponents/ReuseableModal.vue";
import LateTimeDropdown from "../../UIComponents/LateTimeDropdown.vue";
import { normalizeTime } from "src/assets/config/helpers.js";
import EmployeeDropdown from "../../UIComponents/EmployeeDropdown.vue"
import firebase from "firebase";
import Swal from "sweetalert";
import "firebase/database";
import { createActivityPayload, formatValue, getUpdatedFields, logAdminActivity } from "../../../utils/adminLogs";
import PublicHoliday from "./PublicHoliday/index.vue";
import CompanyDetails from "./CompanyDetails.vue";
import SlackIntegration from "./SlackIntegration.vue";
import EmailTemplateManager from "../../EmailTemplate/EmailTemplateManager.vue";
import GoogleCalendarIntegration from '../../GoogleCalender/GoogleCalendarIntegration.vue'
import PerformanceCriteria from "./PerformanceCriteria/index.vue";
import { handleActivityNotification } from "../../../services/notificationService.js";

export default {
  name: "Settings",
  components: {
    CustomTable,
    LateTimeDropdown,
    ReuseableModal,
    WorkingDays,
    Card,
    EmployeeDropdown,
    PublicHoliday,
    CompanyDetails,
    SlackIntegration,
    EmailTemplateManager,
    GoogleCalendarIntegration,
    PerformanceCriteria
  },
  data() {
    const constants = this.$store.state.auth.constants || {};
    const usersData = this.$store.state.auth.allUsers || {};
    let selectedHour = "00";
    let selectedMinute = "00";
    let selectedMeridian = "AM";

    let selectedDays = constants.days || [];
    let productiveHours = constants.totalHours || 8;
    let leavesAllowed = "";
    let leavesAvailable = "";
   let screenshotEnabled =
  constants.screenshotEnabled !== null &&
  constants.screenshotEnabled !== undefined
    ? constants.screenshotEnabled
    : false;
    if (constants.late) {
      const [hours, minutes] = constants.late.split(':').map(Number);
      selectedMeridian = hours >= 12 ? "PM" : "AM";
      selectedHour = String(hours % 12 || 12).padStart(2, "0");
      selectedMinute = String(minutes ? minutes : 0).padStart(2, "0");
    }

    const selectedDaysObject = {
      option: { value: 'custom', label: 'Custom' }, 
      customDays: selectedDays
    };

    const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
    const exceptSunday = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    
    if (JSON.stringify(selectedDays.sort()) === JSON.stringify(allDays.sort())) {
      selectedDaysObject.option = { value: 'all', label: 'All days' };
    } else if (JSON.stringify(selectedDays.sort()) === JSON.stringify(weekdays.sort())) {
      selectedDaysObject.option = { value: 'except-weekend', label: 'Except weekend' };
    } else if (JSON.stringify(selectedDays.sort()) === JSON.stringify(exceptSunday.sort())) {
      selectedDaysObject.option = { value: 'except-sunday', label: 'Except Sunday' };
    }

    const employeeList = Object.keys(usersData).map((userId) => {
      const user = usersData[userId];
      const workingDays = user.workingDays ? [...user.workingDays] : [...(constants.days || [])]; // Deep copy

      const workingDaysObject = {
        option: { value: 'custom', label: 'Custom' },
        customDays: workingDays
      };
      if (JSON.stringify(workingDays.sort()) === JSON.stringify(allDays.sort())) {
        workingDaysObject.option = { value: 'all', label: 'All days' };
      } else if (JSON.stringify(workingDays.sort()) === JSON.stringify(weekdays.sort())) {
        workingDaysObject.option = { value: 'except-weekend', label: 'Except weekend' };
      } else if (JSON.stringify(workingDays.sort()) === JSON.stringify(exceptSunday.sort())) {
        workingDaysObject.option = { value: 'except-sunday', label: 'Except Sunday' };
      }
      const hasCustomSettings =
        (user.lateTime != null && user.lateTime !== constants.late) ||
        (user.productiveHours != null && user.productiveHours !== constants.totalHours) ||
        (user.workingDays != null && JSON.stringify(user.workingDays.sort()) !== JSON.stringify(constants.days.sort())) ||
        (user.screenshotEnabled != null &&  user.screenshotEnabled !== constants.screenshotEnabled);
      return {
        id: usersData[userId].uid || userId,
        username: user.username || "Unknown",
        email: user.email || "",
        phoneNumber: user.phoneNumber || "",
        isActive: user.isActive || false,
        role: user.role || "user",
        salary: user.salary || 0,
        lateTime: user.lateTime || `${selectedHour}:${selectedMinute} ${selectedMeridian}`,
        productiveHours: user.productiveHours || constants.totalHours, 
        leavesAllowed: user.leavesAllowed || "",
        leavesAvailable: user.leavesAvailable || "", 
        workingDays: workingDays,
        workingDaysObject: workingDaysObject,
        screenshotEnabled:
        user.screenshotEnabled !== null && user.screenshotEnabled !== undefined
          ? user.screenshotEnabled
          : constants.screenshotEnabled,
        customSetting: hasCustomSettings,
        specificSetting: user.specificSetting || false,
        hours: Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, "0")),
        minutes: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, "0")),
        meridians: ["AM", "PM"]
      }
    });
    
    this.$store.commit("setEmployeeList", employeeList);

    const currentEmployee = employeeList.find((employee) => employee.id === this.$store.state.auth.user.uid)

    if (currentEmployee && currentEmployee.customSetting) {
      selectedDays = [...currentEmployee.workingDays]; // Deep copy
      productiveHours = currentEmployee.productiveHours;
      leavesAllowed= currentEmployee.leavesAllowed;
      leavesAvailable = currentEmployee.leavesAvailable;
      screenshotEnabled = currentEmployee.screenshotEnabled;
      const [hours, minutes] = currentEmployee.lateTime.split(':').map(Number);
      selectedMeridian = hours >= 12 ? "PM" : "AM";
      selectedHour = String(hours % 12 || 12).padStart(2, "0");
      selectedMinute = String(minutes ? minutes : 0).padStart(2, "0");
    } else {
      selectedDays = [...(constants.days || [])]; // Deep copy
      productiveHours = constants.totalHours;
      leavesAllowed= "";
      leavesAvailable = "";
      screenshotEnabled = constants.screenshotEnabled;
      const [hours, minutes] = constants.late.split(':').map(Number);
      selectedMeridian = hours >= 12 ? "PM" : "AM";
      selectedHour = String(hours % 12 || 12).padStart(2, "0");
      selectedMinute = String(minutes ? minutes : 0).padStart(2, "0");
    }
    return {
      currentUser: this.$store.state.auth.user,
      activeTab: "general",
      filteredUsers:[],
      isAdmin: this.$store.state.auth.user && this.$store.state.auth.user.role === 'admin',
      isSuperAdmin: !!(this.$store.state.auth.user && this.$store.state.auth.user.isSuperAdmin === true),
      activeLateDropdown: null,
      tempLateTime: {},
      weekDays: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      selectedDays,
      selectedDaysObject, 
      productiveHours,
      leavesAllowed,
      leavesAvailable,
      screenshotEnabled,
      late: constants.late || "",
      employeeList: employeeList,
      isDropdownOpen: false,
      selectedHour,
      selectedMinute,
      selectedMeridian,
      hours: Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, "0")),
      minutes: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, "0")),
      meridians: ["AM", "PM"],
      tableColumns: [
        { key: "username", label: "Employee Name", sticky: "left", sortable: true, width: 150 },
        { key: "lateTime", label: "Late Time" },
        { key: "productiveHours", label: "Total Hours" },
        { key: "workingDays", label: "Working Days" },
        { key: "leavesAllowed", label: "leaves Allowed" },
        { key: "leavesAvailable", label: "Leaves Available" },
        { key: "screenshot", label: "Screenshot" },
        { key: "specific", label: "Specific/General" },
        { key: "action", label: "Action", sticky: "right", width: 95 }
      ],
      showUpdateModal: false,
      showResetModal: false,
      selectedEmployee: null,
      tempInputValues: {} 
    };
  },
  computed: {
    constants() {
      const data = this.$store.getters["constants/getConstants"]();
      return data || {};
    },
    filteredEmployeeList() {
      const company = this.$store.state.auth.company;
      const companyUserIds = this.filteredUsers.map(user => user.uid);
      const employeeList = this.$store.state.auth.employeeList || this.employeeList;
      return employeeList.filter(employee =>
        companyUserIds.includes(employee.id)
      );
    },
    hourOptions() {
      return this.hours.map((hour) => ({ value: hour, label: hour }));
    }
  },
  watch: {
    selectedDaysObject: {
      handler(newVal) {
        this.selectedDays = [...newVal.customDays]; // Deep copy
      },
      deep: true
    },
    constants: {
      handler(val) {},
      deep: true,
      immediate: true
    }
  },
  methods: {
    onCalendarConnected() {
      console.log('Google Calendar connected')
      // optional: save flag to backend
    },
    onCalendarDisconnected() {
      console.log('Google Calendar disconnected')
    },
    updateWorkingDays(employee, ReceivedDaysObject) {

      const dayMap = {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      };

      const rawCustomDays = ReceivedDaysObject.customDays || [];

      const normalizedDays = rawCustomDays.map(day => {
        const lower = day.toLowerCase();
        return dayMap[lower] || day;
      });

      const workingDaysObject = {
        option: ReceivedDaysObject.option || {},
        customDays: normalizedDays
      };

      // Update both the original employee and the employeeList entry
      const employeeIndex = this.employeeList.findIndex(emp => emp.id === employee.id);
      if (employeeIndex !== -1) {
        this.$set(this.employeeList[employeeIndex], 'workingDays', [...normalizedDays]);
        this.$set(this.employeeList[employeeIndex], 'workingDaysObject', { ...workingDaysObject });
      }

      // Update the passed-in employee directly as well
      this.$set(employee, 'workingDays', [...normalizedDays]);
      this.$set(employee, 'workingDaysObject', { ...workingDaysObject });

      // Commit to Vuex to ensure global reactivity
      this.$store.commit("setEmployeeList", [...this.employeeList]);
    }
,
    handleInput(event, id, field) {
      this.tempInputValues[`${id}_${field}`] = event.target.value;
    },
    commitInput(id, field) {
      const value = this.tempInputValues[`${id}_${field}`];
      if (value !== undefined) {
        const updatedList = this.employeeList.map(emp => {
          if (emp.id === id) {
            return { ...emp, [field]: Number(value) };
          }
          return emp;
        });
        this.employeeList = updatedList;
        this.$store.commit("setEmployeeList", updatedList);
        delete this.tempInputValues[`${id}_${field}`];
      }
    },
    toggleLateTime(id) {
      this.activeLateDropdown = this.activeLateDropdown === id ? null : id;
      if (this.activeLateDropdown) {
        const employee = this.employeeList.find(emp => emp.id === id);
        if (employee) {
          const [hour, minute] = employee.lateTime.split(':');
          const [minuteValue, meridian] = minute.split(' ');
          this.tempLateTime = {
            hour,
            minute: minuteValue,
            meridian
          };
        }
      }
    },
    onHourChange(selectedHour) {
      this.selectedHour = selectedHour; 
    },
    onLateTimeChange(value, id, type) {
      if (type === 'hour') {
        this.tempLateTime.hour = value;
      } else if (type === 'minute') {
        this.tempLateTime.minute = value;
      } else if (type === 'meridian') {
        this.tempLateTime.meridian = value;
      }
    },
    saveLateTime(id) {
      const employee = this.employeeList.find(emp => emp.id === id);
      if (employee) {
        employee.lateTime = `${this.tempLateTime.hour}:${this.tempLateTime.minute} ${this.tempLateTime.meridian}`;
      }
      this.activeLateDropdown = null; 
    },
    showUpdateConfirmModal(employee) {
      this.selectedEmployee = employee;
      this.showUpdateModal = true;
    },
    showResetConfirmModal(employee) {
      this.selectedEmployee = employee;
      this.showResetModal = true;
    },
    confirmUpdateEmployee() {
      if (this.selectedEmployee) {
        this.updateEmployee(this.selectedEmployee);
        this.showUpdateModal = false;
      }
    },
    confirmResetEmployee() {
      if (this.selectedEmployee) {
        this.resetEmployee(this.selectedEmployee);
        this.showResetModal = false;
      }
    },
    async updateEmployee(employee) {
      console.log("Updating employee:", employee);
      this.$store.commit("loadingStarts");
      const usersList = this.$store.state.auth.allUsers || {};
      const constants = this.$store.state.auth.constants || {};
      const userId = employee.id;
      const filteredUser = Object.values(usersList).find(user => user.uid === userId);

      const normalizedEmpLate = normalizeTime(employee.lateTime);
      const normalizedUserLate = normalizeTime(filteredUser.lateTime);
      const normalizedConstLate = normalizeTime(constants.late);

      const isProductiveHoursChanged =
        employee.productiveHours !== filteredUser.productiveHours &&
        employee.productiveHours !== constants.totalHours;

      const isScreenshotEnabledChanged =
        employee.screenshotEnabled !== filteredUser.screenshotEnabled 

      const isWorkingDaysChanged =
        JSON.stringify(employee.workingDays) !== JSON.stringify(filteredUser.workingDays) &&
        JSON.stringify(employee.workingDays) !== JSON.stringify(constants.days);

      const isLateTimeChanged =
        normalizedEmpLate !== normalizedUserLate &&
        normalizedEmpLate !== normalizedConstLate;

      let updatedFields = {};

      if (isProductiveHoursChanged) {
        updatedFields.productiveHours = employee.productiveHours;
      }
      updatedFields.leavesAvailable = employee.leavesAvailable;
      updatedFields.leavesAllowed = employee.leavesAllowed;

      if (isScreenshotEnabledChanged) {
        updatedFields.screenshotEnabled = employee.screenshotEnabled;
      }

      if (isWorkingDaysChanged) {
        updatedFields.workingDays = [...employee.workingDays];
      }

      if (isLateTimeChanged) {
        updatedFields.lateTime = employee.lateTime;
      }

      const isSpecific =
        updatedFields.productiveHours ||
        updatedFields.screenshotEnabled ||
        updatedFields.lateTime ||
        JSON.stringify(updatedFields.workingDays)

      if (isSpecific) {
        updatedFields.specificSetting = true;
        updatedFields.customSetting = true;
      }

      await firebase.database().ref(`users/${employee.id}`).update(updatedFields)
        .then(async () => {
          this.$store.commit("loadingEnds");
          const updatedEmployeeList = this.employeeList.map(emp => {
            if (emp.id === employee.id) {
            return {
              ...emp,
              ...updatedFields,
            };
          }
          return emp;
        });

        this.employeeList = updatedEmployeeList;
        this.$store.commit("setEmployeeList", updatedEmployeeList);

        Swal("Success!", "Employee updated successfully!", "success");

          let changes = getUpdatedFields(filteredUser, updatedFields);
          changes = Object.entries(changes)
              .map(([key, value]) => `${key}: ${formatValue(value.old)} → ${formatValue(value.new)}`)
              .join('\n');

          const admin = this.currentUser;
          const { id: uid, username, email } = employee;

          const title = `${admin.username} updated specific settings for ${username}`;
          const description =
            `${admin.email} updated specific settings for ${email}.`;

          await logAdminActivity(
            createActivityPayload({
              user: admin,
              title,
              description,
              changes,
              username,
              type: "settings",
              uid,
            })
          );

          await handleActivityNotification(
            {
              type: "settings",
              activityDescription: description,
              activityOnUser: uid,
              activityOnUserName: username, 
              activityByUserName: this.currentUser.username,
            },
            this.$store.state.auth,
            this.currentUser.uid
          );
      })
      .catch((err) => {
        this.$store.commit("loadingEnds");
        Swal("Error!", err.message, "error");
      });
    },
    
    toggleDropdown(role) {
      if (role) {
        this.isDropdownOpen = !this.isDropdownOpen;
      }
    },
    setHour(hour) {
      this.selectedHour = hour;
      this.isDropdownOpen = false;
    },
    setMinute(minute) {
      this.selectedMinute = minute;
      this.isDropdownOpen = false;
    },
    setMeridian(meridian) {
      this.selectedMeridian = meridian;
      this.isDropdownOpen = false;
    },
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isDropdownOpen = false;
      }
      if (
        this.$refs.dropdown_employee &&
        Array.isArray(this.$refs.dropdown_employee) &&
        !this.$refs.dropdown_employee.some((el) => el.contains(event.target))
      ) {
        this.activeLateDropdown = null;
      }
    },
    async saveGeneralSettings() {
      this.$store.commit("loadingStarts");
      const oldConstants = { ...this.constants };
      const lateTime = `${this.selectedHour}:${this.selectedMinute} ${this.selectedMeridian}`;
      const lateTime24 = this.convertTo24Hour(lateTime);
      const updatedConstants = {
        late: lateTime24,
        days: [...this.selectedDays],
        totalHours: this.productiveHours,
        screenshotEnabled: this.screenshotEnabled,
      };
      firebase
        .database()
        .ref("constants")
        .update(updatedConstants)
        .then( async () => {
          this.$store.commit("setConstants", { ...this.$store.state.auth.constants, ...updatedConstants });
          const updatedEmployeeList = this.employeeList.map((employee) => {
            if (!employee.customSetting) {
              const defaultDays = [...(updatedConstants.days || [])];
              const allDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
              const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
              const exceptSunday = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
              let workingDaysOption = { value: "custom", label: "Custom" };
              if (JSON.stringify([...defaultDays].sort()) === JSON.stringify([...allDays].sort())) {
                workingDaysOption = { value: "all", label: "All days" };
              } else if (JSON.stringify([...defaultDays].sort()) === JSON.stringify([...weekdays].sort())) {
                workingDaysOption = { value: "except-weekend", label: "Except weekend" };
              } else if (JSON.stringify([...defaultDays].sort()) === JSON.stringify([...exceptSunday].sort())) {
                workingDaysOption = { value: "except-sunday", label: "Except Sunday" };
              }
              return {
                ...employee,
                lateTime: lateTime, 
                productiveHours: updatedConstants.totalHours,
                workingDays: defaultDays,
                workingDaysObject: {
                  option: workingDaysOption,
                  customDays: defaultDays,
                },
                screenshotEnabled: updatedConstants.screenshotEnabled,
              };
            }
            return employee;
          });
          this.employeeList = updatedEmployeeList;
          this.$store.commit("setEmployeeList", updatedEmployeeList);
          this.$store.commit("loadingEnds");
          Swal("Success!", "General settings saved!", "success");
          
          const updatedFields = getUpdatedFields(oldConstants, updatedConstants);
          const changes = Object.entries(updatedFields)
              .map(([key, value]) => `${key}: ${formatValue(value.old)} → ${formatValue(value.new)}`)
              .join('\n');
          let title = `${this.currentUser.username} updated general settings`;
          let description = `${this.currentUser.email} updated general settings.`;

          await logAdminActivity(
            createActivityPayload({
              user: this.currentUser,
              title,
              description,
              changes,
              type: "settings",
            })
          );
          await handleActivityNotification(
            {
              type: "settings",
              activityDescription: description,
              activityByUserName: this.currentUser.username,
            },
            this.$store.state.auth,
            this.currentUser.uid
          );
          this.$store.dispatch("constants/fetchConstants").then(() => {
     
          });
        })
        .catch((err) => {
          this.$store.commit("loadingEnds");
          Swal("Error!", err.message, "error");
        });
    },
    convertTo24Hour(time) {
      let [timePart, meridian] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);
      if (meridian === "PM" && hours !== 12) hours += 12;
      if (meridian === "AM" && hours === 12) hours = 0;
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    },
    resetEmployee(employee) {
      this.$store.commit("loadingStarts");
      const employeeRef = firebase.database().ref(`users/${employee.id}`);
      employeeRef
        .once("value")
        .then((snapshot) => {
          const currentEmployee = snapshot.val();
          const constants = this.$store.state.auth.constants;
          const resetFields = {
            lateTime: null,  
            productiveHours: null,
            workingDays: null, 
            screenshotEnabled: null,
            customSetting: false ,
            specificSetting: null 
          };
          employeeRef.update(resetFields).then(() => {
            const employeeIndex = this.employeeList.findIndex(
              (e) => e.id === employee.id
            );
            if (employeeIndex !== -1) {
              const defaultDays = [...(constants.days || [])];
              const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
              const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
              const exceptSunday = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              let workingDaysOption = { value: 'custom', label: 'Custom' };
              if (JSON.stringify([...defaultDays].sort()) === JSON.stringify([...allDays].sort())) {
                workingDaysOption = { value: 'all', label: 'All days' };
              } else if (JSON.stringify([...defaultDays].sort()) === JSON.stringify([...weekdays].sort())) {
                workingDaysOption = { value: 'except-weekend', label: 'Except weekend' };
              } else if (JSON.stringify([...defaultDays].sort()) === JSON.stringify([...exceptSunday].sort())) {
                workingDaysOption = { value: 'except-sunday', label: 'Except Sunday' };
              }
              const updatedEmployee = {
                ...employee,
                lateTime: `${this.selectedHour}:${this.selectedMinute} ${this.selectedMeridian}`,
                productiveHours: this.productiveHours,
                workingDays: defaultDays,
                workingDaysObject: {
                  option: workingDaysOption,
                  customDays: defaultDays
                },
                screenshotEnabled: this.screenshotEnabled,
                customSetting: false,
                specificSetting: false
              };
              const updatedEmployees = [...this.employeeList];
              updatedEmployees[employeeIndex] = updatedEmployee;
              this.employeeList = updatedEmployees;
              this.$store.commit("setEmployeeList", updatedEmployees);
              Swal("Success!", "Reset settings saved!", "success");
            }
            this.$store.commit("loadingEnds");
          });
        })
        .catch((error) => {
          Swal("Error", "Could not reset employee settings", "error");
          this.$store.commit("loadingEnds");
        });
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.tabs {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 10px;
    width: 100%;
    position: relative;
}

.empoyee-dropdown-container{
  position: absolute;
  left:0;
  top:8px
}
.tab-container{
  display: flex;
  justify-content: start;
  gap: 10px;
  margin-bottom: 10px;
  width: 100%;
  position: relative; 
}
.left-section{
 display: none
}

@media (max-width: 1477px) {
  .tab-container {
    display: flex;
    flex-direction: column-reverse; 
    justify-content:start;
    margin-bottom: 10px;
  }
  .left-section{
    display: block;
    border: 2px sold red
  }
  .tabs button{
    padding: 8px 20px;
    font-size: 16px;
    font-weight: 600;
  }
  .tabs {
      justify-content: start !important;
      flex-wrap : wrap;
      font-size: 10px;
      gap: 5px;

  }
  .empoyee-dropdown-container{
    position: relative;
    left:0;
    top:-20px;
    margin-bottom : 35px
    
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings.vue